import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';
import { Link } from 'react-router-dom';

export default function LatestUpdates() {
  const latest = [...comics]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 12);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              下拉式漫画大全，每日同步更新热门韩国漫画
            </p>
          </div>
          <Link
            to="/category/fantasy"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {latest.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/fantasy"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}